/// <amd-module name="SearchUI/FilterBar" />
export * from './Components/FilterBar/index';
